<template>
  <v-card :dark="complexity !== '1'" :color="cellColor" :hover="hover" v-on:mouseover="mouseOver" v-on:mouseleave="showButtons=false">
    <v-container grid-list-xs align-content-space-between d-flex fill-height>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card-text class="caption" v-t="{path: 'ITEM'+item+'.SHORTTITLE', locale: version}" />

          <v-card-actions class="pa-0" v-show="!hideButtons">
            <v-btn icon :dark="complexity === '1'" @click.native="dialogHelp = true">
              <v-icon light dark>info_outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon :dark="complexity === '1'" @click.native="showAssist()">
              <v-icon light dark>live_help</v-icon>
            </v-btn>
          </v-card-actions>

        </v-flex>
      </v-layout>
    </v-container>
    <evaloe-assist :questionnaire-items="this.recommendations"
                   :version="version"
                   :incorporateHelp="this.incorporateHelp"
                   :incorporateKey="item"
                   v-on:close="closeAssist"
    ></evaloe-assist>
    <v-dialog v-model="dialogHelp" lazy scrollable max-width="70%">
      <v-card>

        <v-card-text>
          <v-card-title class="title" v-t="{path: 'ITEM'+item+'.TITLE', locale: version}"></v-card-title>
          <span v-html="$t('ITEM'+item+'.ITEM_EXPLANATION', version)"></span>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="dialogHelp = false">
            <span v-html="$t('questionnaire.itemHelpDialog.CLOSE_BUTTON')"></span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import EvaloeAssist from '@/components/questionnaires/EvaloeAssist'
  export default {
    name: 'evaloeResultsItem',
    components: {
      'evaloe-assist': EvaloeAssist
    },
    props: ['complexity', 'item', 'version', 'answered', 'answer', 'chosen', 'hover'],
    data () {
      return {
        incorporateHelp: false,
        showButtons: false,
        recommendations: [],
        dialogHelp: false
      }
    },
    computed: {
      cellColor: function () {
        var col = ''
        switch (this.complexity) {
          case '3':
            col = 'deep-purple darken-4'
            break
          case '2':
            col = 'deep-purple lighten-1'
            break
          case '1':
            col = 'deep-purple lighten-4'
            break
          default:
            col = ''
            break
        }
        return col
      },
      hideButtons: function () {
        return !this.showButtons && (!this.incorporateHelp || !this.dialogHelp)
      }
    },
    methods: {
      showAssist: function () {
        this.incorporateHelp = true
      },
      closeAssist: function () {
        this.incorporateHelp = false
      },
      mouseOver: function () {
        this.showButtons = true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/questionnaires/EvaloeItem.vue